// Angular environment configuration for development
export const environment = {
    production: false,
    apiUrl: 'https://dev.goexpats.com/api/',
    apiTimeout: 30000,
    enableAnalytics: false,
    enableErrorTracking: false,
    logLevel: 'debug',
};
